// Bu fonksiyon Supabase ile bağlantı kurmak için kullanılır
import { createClient } from '@supabase/supabase-js'

// Create React App (CRA) ortam değişkenlerini alıyoruz
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL // Supabase proje URL'si
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY // Supabase anonim (public) anahtarı

// Supabase istemcisini oluşturuyoruz ve dışa aktarıyoruz
// Bu istemci tüm uygulama boyunca veritabanı işlemleri için kullanılacak
export const supabase = createClient(supabaseUrl, supabaseAnonKey)


